import React from 'react';
import { color, boxShadow } from '../constants';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import { ReactComponent as CopyLogo } from '../imnages/copyright.svg';

const MainCont = styled.div`
  margin-top: 2rem;
  padding: 1rem;
  border-radius: .5rem;
  box-shadow: ${boxShadow.outset};
  display: flex;
  justify-content: space-between;
  user-select: none;
  font-size: 11px;
  margin-bottom: 1rem;
  @media(min-width: 576px){
    font-size: 1rem;
  }
`
const ItemsCont = styled.div`
  display: flex;
  align-items: center;
`
const Info = styled.p`
  margin: 0;
  margin-left: ${({ first }) => first ? 0 : "1rem"};
  text-transform: capitalize;
`
const Name = styled(Info)`
  color: ${color.prim};
  font-weight: bold;
`
export default ()=> (
  <Container>
    <MainCont>
      <ItemsCont>
        <CopyLogo with="20px" height="20px" />
        <Info>copyright - 2020</Info>
      </ItemsCont>
      <ItemsCont>
        <Info first>powered by: </Info>
        <Name>felix tineo</Name>
      </ItemsCont>
    </MainCont>
  </Container>
)
